import { GET_USER_DATA, DELETE_USER_DATA, GET_USER_COUNT, GET_USER, GET_FAV_LESSON } from "../actions/types";

const intialstate = {
    loading: false,
    users: [],
    count: [],
    alldata: [],
    fav_lesson: [],
    error: ''
}
const userReducer = (state = intialstate, action) => {
    switch (action.type) {
        case GET_USER_DATA:
            return {
                ...state,
                loading: true,
                users: action.payload,
                error: ''
            };
        case DELETE_USER_DATA:
            return {
                ...state
            };
        case GET_USER_COUNT:
            return {
                ...state,
                count: action.payload,
            } 
        case GET_USER:{
            return {
                ...state,
                alldata: action.payload,
            } 
        }  
        case GET_FAV_LESSON:{
            return {
                ...state,
                fav_lesson: action.payload,
            } 
        }       
        default:
            return state
    }
}

export default userReducer
